import axios from "axios";
import formatCPF from "./formatCPF";


export default function checkCpf(value) {      
 
       return axios.get(`https://api.nfse.io/validate/NaturalPeople/taxNumber/${value}`).then(
            response => { return response.data},
            error => { return error}
        )


}  